<template>
  <div class="not-found">
    <div class="not-found-content">
      <h1 class="not-found-title">404</h1>
      <p class="not-found-message">当前地址无效，请点击下方按钮登录系统</p>
      <router-link to="/" class="go-home-btn">去登录</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f7f7;
  font-family: 'Arial', sans-serif;
}

.not-found-content {
  text-align: center;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.not-found-title {
  font-size: 80px;
  font-weight: 700;
  color: #f44336;
  margin: 0;
}

.not-found-message {
  font-size: 18px;
  color: #555;
  margin: 20px 0;
}

.go-home-btn {
  display: inline-block;
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border-radius: 30px;
  text-decoration: none;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.go-home-btn:hover {
  background-color: #0056b3;
}
</style>
